import React, { PropTypes } from 'react';
import QuestionRow from './QuestionRow';

const QuestionRowList = ({ questions, ...others }) => {
  return (
    <div>
      {questions.map(question => (
        <QuestionRow key={question.id} question={question} {...others} />
      ))}
    </div>
  );
};

QuestionRowList.propTypes = {
  questions: PropTypes.array.isRequired,
};

export default QuestionRowList;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/QuestionRowList.js